import React from 'react'
import PropTypes from 'prop-types'
import Text from '#components/a/Text'

function ChatInfoItem({messageText}) {
  return (
    <div className="chat-info-item-wrapper">
      <div className="chat-info-item">
        <Text text={messageText} />
      </div>
    </div>
  )
}

ChatInfoItem.propTypes = {
  messageText: PropTypes.string.isRequired,
}

export default ChatInfoItem
